import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import { Fragment } from 'react';
import { PostCategoryProps } from '../types';
import { formatDate } from '../utils/helpers';

interface SiteProps {
  siteTitle?: string;
  favicon?: {
    publicURL: string;
    childImageSharp?: ImageDataLike;
  };
}
interface Props {
  date?: string;
  categories?: PostCategoryProps[];
  externalSite?: SiteProps;
  isStory?: boolean;
}

function PostMetaSite({ site }: { site?: SiteProps }) {
  if (!site) {
    return null;
  }

  const gatsbyImage = site.favicon?.childImageSharp
    ? getImage(site.favicon.childImageSharp)
    : null;
  const publicURL = site.favicon?.publicURL;

  return (
    <li>
      <div
        className={`post-entry__meta__site ${
          !site.favicon ? 'post-entry__meta__site--no-icon' : ''
        }`}
      >
        {site.favicon && (
          <div className="post-entry__meta__site__icon">
            {(site.favicon && gatsbyImage && (
              <GatsbyImage image={gatsbyImage} alt={site.siteTitle || ''} />
            )) ||
              (publicURL && (
                <img
                  src={publicURL}
                  alt={site.siteTitle || ''}
                  height="32"
                  width="32"
                  loading="lazy"
                />
              ))}
          </div>
        )}
        {(site.siteTitle && <span>{site.siteTitle}</span>) || (
          <span>&nbsp;</span>
        )}
      </div>
    </li>
  );
}

export default function PostMeta({
  date,
  categories,
  externalSite,
  isStory = false,
}: Props) {
  const hasExternalSite = externalSite?.siteTitle || externalSite?.favicon;
  return (
    <div className="post-entry__meta small">
      <div className="post-entry__meta__inner">
        <ul>
          {date && (
            <li>
              <time dateTime={date}>{formatDate(date, true)}</time>
            </li>
          )}
          {!!categories?.length && !hasExternalSite && (
            <li>
              {categories.map((category, i) => {
                const categoryUrl = isStory
                  ? '/videos'
                  : `/news-press/${category.slug}`;
                return (
                  <Fragment key={`cat-${category.slug}`}>
                    {i > 0 && ', '}
                    <a href={categoryUrl}>{category.name}</a>
                  </Fragment>
                );
              })}
            </li>
          )}
          {hasExternalSite && <PostMetaSite site={externalSite} />}
        </ul>
      </div>
    </div>
  );
}
